import { parseDatasetString } from 'utilities';
import { getTypeOfFrequencyDataSet } from 'calculators/dataset/frequencyTable';
import { RAW, FREQUENCY } from 'scenes/Dataset/components/constants';

const ADDITION_INFO = 'ADDITION_INFO';
const ERROR = 'error';
const SUCCESS = 'success';

/*
  * external data is a combination of CSV string (data) and JSON string (setting)
*/
const separateSettingAndData = externalData => {
  const settingPosition = externalData.indexOf(ADDITION_INFO, 0);
  let settingAsJsonString = null;
  if (settingPosition > 0) {
    settingAsJsonString = externalData.slice(settingPosition + ADDITION_INFO.length);
  }
  const csvData = externalData.slice(0, settingPosition);
  return {
    setting: settingAsJsonString,
    csvData
  };
};
const loadDataAsCsvFromExternalApp = toast => {
  let csvString = '';
  const passedData = document.getElementById('receivedMessage');

  if (passedData && passedData.value !== 'nothing received') {
    toast.success(
      'Your data has been transferred from WebAssign successfully!',
      {
        position: toast.POSITION.TOP_CENTER,
        className: 'toastContainer'
      }
    );
    csvString = passedData.value;
  }
  return csvString;
};

const extractDataAndAdditionalInfo = externalData => {
  // Step 1: Separate CSV string(data) and JSON string(Setting)
  const { setting, csvData } = separateSettingAndData(externalData);
  // Step 2: create dataset from csv
  const dataset = parseDatasetString(csvData) || null;
  // Step 3: Create JSON to get setting data from json string
  let additionInfo = null;
  try {
    additionInfo = JSON.parse(setting);
  } catch {
    // what we show when we pass not correct settings to SALT?
    return {
      status: ERROR,
      mode: RAW,
      data: dataset
    };
  }

  // Step 4: Check is it frequency dataset from setting, if not return as regular data
  const isFrequencyDatatype = (additionInfo && additionInfo.type === 'frequency');
  if (!isFrequencyDatatype) {
    return {
      status: SUCCESS,
      mode: RAW,
      data: dataset
    };
  }

  // Step 5: Parse Dataset to identify its Frequency or Relative Frequency for "Frequency Table"
  // Error Case: Dataset might have bad data ( ex: string when number is expected) which can't be used in frequency,
  // in that case return as regular data
  const frequencyDatasetTypeFromRecords = getTypeOfFrequencyDataSet(dataset);
  if (!frequencyDatasetTypeFromRecords) {
    return {
      status: ERROR,
      mode: RAW,
      data: dataset
    };
  }

  // Step 6: Return as Frequency Dataset
  // Frequency Dataset Example:
  //
  //	    |      Col header	      |
  // Name	| col1  | col2  | col3  | Total
  //
  // additionInfo.nameOfColumns: "Col header" (Col header is the name for three columns col1, col2, col3)
  // if nameOfColumns isn't given, we use default common name: 'Category'
  // additionInfo.type: frequency
  // eslint-disable-next-line no-nested-ternary
  const frequencyColumnsName = additionInfo.nameOfColumns ? additionInfo.nameOfColumns : frequencyDatasetTypeFromRecords === 'contingency' ? 'Category' : '';
  return {
    status: SUCCESS,
    mode: FREQUENCY,
    data: dataset,
    // Frequency or Relative Frequency
    frequencyType: frequencyDatasetTypeFromRecords,
    // Frequency Table with more than two columns might have this information
    frequencyColumnsName
  };
};


export {
  loadDataAsCsvFromExternalApp,
  extractDataAndAdditionalInfo
};
